'use client';
import React, { useState, useEffect } from 'react';
import ControlSidebar from './ControlSidebar';
import ControlTopbar from './ControlTopbar';

interface ControlLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  lastUpdated?: string;
}

export default function ControlLayout({ children, title, subtitle, lastUpdated }: ControlLayoutProps) {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('aac-control-theme');
    if (stored === 'dark') {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleDark = () => {
    const next = !isDark;
    setIsDark(next);
    if (next) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('aac-control-theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('aac-control-theme', 'light');
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <ControlSidebar isDark={isDark} onToggleDark={toggleDark} />
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <ControlTopbar title={title} subtitle={subtitle} lastUpdated={lastUpdated} />
        <main className="flex-1 overflow-y-auto scrollbar-thin bg-background">
          <div className="max-w-screen-2xl mx-auto px-6 py-6 lg:px-8 xl:px-10 2xl:px-12">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}